var _rect, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 229,
    viewBox: "0 0 194 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.3516,
    y: 6.91016,
    width: 131,
    height: 179,
    rx: 24,
    transform: "rotate(2.95434 62.3516 6.91016)",
    fill: "#E5E7EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2315_12320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.8281,
    y: 28.0703,
    width: 131,
    height: 179,
    rx: 20,
    transform: "rotate(-5.99479 18.8281 28.0703)",
    fill: "#F6F6F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2926 100.423L92.9801 106.971M94.3552 120.065L94.3879 120.062M73.0497 135.542L118.411 130.778C123.451 130.249 126.028 124.462 123.05 120.362L96.2438 83.4595C93.2654 79.3592 86.9652 80.0208 84.9035 84.6503L66.3482 126.316C64.2865 130.946 68.0096 136.071 73.0497 135.542Z",
    stroke: "#818CF8",
    strokeWidth: 6.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2315_12320",
    x: 0.804688,
    y: 0.367188,
    width: 185.023,
    height: 227.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2315_12320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2315_12320",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404);
export default __webpack_public_path__ + "static/media/NotFound404.5a0cbd00248c48b91af8e02da8554ccf.svg";
export { ForwardRef as ReactComponent };